
const HeaderStyle = theme => ({
    headerContainer: {
        minHeight: "56px",
        justifyContent: "space-between",
        width: "100%"
    },
    headerLogoImg: {
        height: 33,
        minHeight: 33,
        maxHeight: 33
    },
    logoPng: {
        height: "100%",
        marginLeft: "2rem",
        display: "inline-block",
        cursor: "default"
    },

    avatarWrapper: {
        height: "100%",
        marginLeft: "2rem",
        display: "flex",
        alignItems: "center",
        cursor: "default"
    },
    welcomeText: {
        marginRight: 20,
        color: "#6D7278",
        fontSize: "20px"
    },
    avatar: {
        backgroundColor: "#A8BBBB",
        width: "40px",
        height: "40px",
        fontWeight: "bolder",
        cursor: "pointer",
        fontFamily: "Proxima Nova",
    },
    dFlex: {
        display: "flex"
    },
    alignItemsCenter: {
        alignItems: "center"
    },
    w50: {
        width: "50%"
    },
    w25: {
        width: "25%"
    },
    w75: {
        width: "75%"
    },
    floatRight: {
        float: "right"
    },
    flexDirectionRowReverse: {
        flexDirection: "row-reverse"
    },
    marginLeft2: {
        marginLeft: "2rem"
    },
    logoutModal: {
        flexDiretion: "column",
        alignItems: "flex-end"
    },
    RefDiv: {
        position: "absolute",
        top: 124,
        right: 0
    },
    alignCenter: {
        text: "center"
    },
    modalWrapper: {
        height: 82,
        width: 268,
        backgroundColor: "#EDEDED",
        position: "absolute",
        borderRadius: 5,
        top: "70px !important",
        right: 30,
        display: "flex",
        overflow: "hidden",
        boxShadow: "0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)"
    },
    modalBackdrop: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
    },
    menuWrapper: {
        display: "flex",
        flex: 1,
        justifyContent: "space-between",
        alignItems: "center",
        padding: "0px 30px 0px 39px",
        cursor: "pointer"
    },
    menuText: {
        color: "#6D7278",
        fontFamily: "Proxima Nova",
        fontSize: 24,
        letterSpacing: 0,
        lineHeight: "29px"
    },
    menuIcon: {
        height: 50,
        width: 50,
        maxHeight: 50,
        maxWidth: 50,
        objectFit: "cover"
    },
    disabledHeader:{
        backgroundColor: "#e5eaea !important",
        cursor:"default !important"
    }
})

export default HeaderStyle;